import { Container } from "inversify";
import { LandingServiceID } from "./symbols";
import { LandingSessionStore } from "./landing-session.store";
import { LandingRootStore, ILandingRootStore } from "./landing-root.store";
import { RemainingTime } from "./timer";
import type { IRemainingTime } from "@/lib/types/training";
import type { ILandingSessionManager } from "@/lib/types/store";

const container = new Container({
  defaultScope: "Singleton",
});

container
  .bind<ILandingSessionManager>(LandingServiceID.SessionStore)
  .to(LandingSessionStore);

container
  .bind<ILandingRootStore>(LandingServiceID.RootStore)
  .to(LandingRootStore);

container.bind<IRemainingTime>(LandingServiceID.Timer).to(RemainingTime);

export { container, LandingServiceID };
